// extracted by mini-css-extract-plugin
export var logo = "_bg-2";
export var logoWrapper = "_bg-1";
export var strip = "_bg-0";